import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { environment } from '../../../environments/environment';
import { WindowRef } from '../../shared/services/window/window.ref';

@Component({
  selector: 'ssg-error',
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.less']
})
export class ErrorComponent implements OnInit {
  production: boolean;
  status: number;
  errorDescription: string;
  error: string;

  constructor(private route: ActivatedRoute, private window: WindowRef) {
    this.production = environment.production;
  }

  ngOnInit() {
    this.route.paramMap.subscribe(
      (params: ParamMap) => {
        this.status = +params.get('status');
        this.errorDescription = params.get('error_description');
        this.error = params.get('error');
        this.window.nativeWindow.scrollTo(0, 0);
      });
  }

}
